'use client'
import { useEffect, useState } from 'react'
import Image from 'next/image'

import styles from './styles.module.scss'

import PlayImage from '/public/icons/play.svg'

import tracr from '@/utils/tracr'
import Button from '../Button'

const Video = ({
  thumbnailUrl,
  buttonId,
  url,
  className = '',
  text,
  videoAutoplay = false
}) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(videoAutoplay)

  return (
    <section className={`${styles.video} ${className}`}>
      <div className={styles.video__iframe}>
        {!isVideoLoaded ? (
          <div className={styles.video__thumbnailWrapper}>
            <Image
              src={thumbnailUrl}
              alt="Thumbnail do vídeo sobre treinos ao vivo"
              className={styles.video__thumbnail}
              width={1280}
              height={720}
            />
            <Button
              onClick={() => {
                tracr.Events.sendEvent('ElementClicked', {
                  text: '',
                  elementId: buttonId,
                  elementType: 'BUTTON',
                  htmlId: buttonId,
                  outboundUrl: ''
                })
                setIsVideoLoaded(true)
              }}
              variant="transparent"
              className={styles.video__playButton}
              outline={true}
              aria-label="Clique para assistir ao vídeo"
              id={buttonId}
            >
              <Image
                src={PlayImage}
                alt="Aperte o play e assista o vídeo"
                width={80}
                height={80}
              />
              {text && <p className={styles.text}>{text}</p>}
            </Button>
          </div>
        ) : (
          <iframe
            style={{ border: 'none' }}
            id="panda-634aeae1-763c-4a71-a720-6ddca2e14b1b"
            src={url}
            width="100%"
            height="100%"
            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
            allowFullScreen
            fetchPriority="high"
            title="Assista o vídeo da maior academia de aulas online ao vivo do mundo"
          ></iframe>
        )}
      </div>
    </section>
  )
}

export default Video
